import { createCodedError } from '~/common/errors/CodedError';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { camelizeKeys } from '~/redux/api/transformers/utils';
import { testIsAxiosError } from '~/redux/api/utils';
import { everest } from '~/services/serviceInstances';

import { Company, CompanyListResponse } from './types';

interface GetIntegrateWorkflowCompaniesParams {
  searchString: string;
}

export const getIntegrateWorkflowCompanies = async ({
  searchString,
}: GetIntegrateWorkflowCompaniesParams): Promise<Company[]> => {
  try {
    const params = `?q=${encodeURIComponent(searchString)}`;
    const response: CompanyListResponse = await everest.get(
      `/companies${params}`,
    );

    return response.data.map((company) => ({
      ...camelizeKeys(company.attributes),
      id: company.id,
    }));
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors?.[0];
      if (errorResponse) {
        throw createCodedError({
          message: errorResponse.detail ?? errorResponse.title,
          statusCode: errorResponse.status,
          title: errorResponse.title,
        });
      }
    }

    throw error;
  }
};
